// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"7e1d5eaa","5032":"8ccae23f","7562":"f0669493"}[chunkId] + ".chunk.css";
};